<template>
  <div class="mt-0 pt-0">
    <v-card class="elevation-2" outlined>
      <v-card-title class="d-flex flex-wrap align-center" style="gap: 12px;">
        <div>
          <div class="text-h6">Aceptacion de terminos y condiciones</div>
          <div class="text-body-2 text--secondary">
            Contactos que aceptaron los terminos vigentes
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-chip color="green lighten-4" class="green--text text--darken-4" small>
          Total aceptaciones: {{ aceptaciones.length }}
        </v-chip>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-row dense class="mb-2">
          <v-col cols="12" md="5">
            <v-text-field
              v-model="search"
              dense
              outlined
              clearable
              prepend-inner-icon="mdi-magnify"
              label="Buscar contacto"
              hide-details
            />
          </v-col>
          <v-col cols="12" md="7" class="d-flex justify-end align-center" style="gap: 8px;">
            <v-chip v-if="terminos" color="blue lighten-5" class="blue--text text--darken-3" small>
              {{ terminos.title || 'Terminos' }} - {{ terminos.version_code || 'S/V' }}
            </v-chip>
            <v-btn color="green" dark depressed :loading="loading" @click="listar">
              <v-icon left>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>

        <v-alert v-if="msg" dense outlined type="warning" class="mb-3">
          {{ msg }}
        </v-alert>

        <v-data-table
          :headers="headers"
          :items="aceptacionesFiltradas"
          :loading="loading"
          :items-per-page="25"
          dense
          class="elevation-1"
          loading-text="Cargando aceptaciones..."
          no-data-text="No hay aceptaciones para mostrar"
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table" />
          </template>

          <template v-slot:[`item.nombre_completo`]="{ item }">
            {{ nombreCompleto(item.contacto) }}
          </template>

          <template v-slot:[`item.telefono`]="{ item }">
            {{ valorContacto(item, 'telefono') }}
          </template>

          <template v-slot:[`item.correo`]="{ item }">
            {{ valorContacto(item, 'correo') }}
          </template>

          <template v-slot:[`item.asesor_name`]="{ item }">
            {{ valorContacto(item, 'asesor_name') }}
          </template>

          <template v-slot:[`item.origen`]="{ item }">
            {{ valorContacto(item, 'origen') }}
          </template>

          <template v-slot:[`item.area_interes_name`]="{ item }">
            {{ valorContacto(item, 'area_interes_name') }}
          </template>

          <template v-slot:[`item.programa_interes_name`]="{ item }">
            {{ valorContacto(item, 'programa_interes_name') }}
          </template>

          <template v-slot:[`item.fecha_de_contacto`]="{ item }">
            {{ parseFecha(valorContacto(item, 'fecha_de_contacto')) }}
          </template>

          <template v-slot:[`item.fecha_registro`]="{ item }">
            {{ parseFecha(item.fecha_registro) }}
          </template>

          <template v-slot:[`item.site_url`]="{ item }">
            <a v-if="item.site_url" :href="item.site_url" target="_blank" rel="noopener">
              {{ item.site_url }}
            </a>
            <span v-else>-</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { terminos_aceptaciones_por, terminos_condiciones } from './utils';

  export default {
    data() {
      return {
        loading: false,
        msg: '',
        search: '',
        terminos: null,
        aceptaciones: [],
        headers: [
          { text: 'Fecha aceptacion', value: 'fecha_registro', width: 150 },
          { text: 'Contacto', value: 'nombre_completo' },
          { text: 'Telefono', value: 'telefono', width: 130 },
          { text: 'Correo', value: 'correo' },
          { text: 'Asesor', value: 'asesor_name' },
          { text: 'Origen', value: 'origen' },
          { text: 'Area interes', value: 'area_interes_name' },
          { text: 'Programa interes', value: 'programa_interes_name' },
          { text: 'Fecha contacto', value: 'fecha_de_contacto', width: 140 },
          { text: 'Sitio', value: 'site_url' },
        ],
      };
    },
    computed: {
      unidadNegocioId() {
        return this.$store.state.CARGO && this.$store.state.CARGO.sede
          ? this.$store.state.CARGO.sede.unidad_negocio
          : null;
      },
      aceptacionesFiltradas() {
        if (!this.search) return this.aceptaciones;
        const q = this.search.toLowerCase();
        return this.aceptaciones.filter((item) => {
          const contacto = item.contacto || {};
          return [
            item.site_url,
            item.fecha_registro,
            contacto.nombres,
            contacto.apellidos,
            contacto.telefono,
            contacto.correo,
            contacto.asesor_name,
            contacto.origen,
            contacto.area_interes_name,
            contacto.profesion_name,
            contacto.programa_interes_name,
            contacto.estado,
          ].some((value) => String(value || '').toLowerCase().includes(q));
        });
      },
    },
    watch: {
      '$store.state.CARGO': function() {
        this.listar();
      },
    },
    methods: {
      async listar() {
        if (!this.unidadNegocioId) return;
        this.loading = true;
        this.msg = '';
        this.aceptaciones = [];

        try {
          const q = {
            unidad_negocio: this.unidadNegocioId,
          };
          // devuelve una lista, por defecto toma al primero; pero en un futuro conviene analizar si esa es la mejor manera
          let terminos = await terminos_condiciones(q);
          if(terminos && terminos.length>0) terminos = terminos[0];

          // window.console.log('terminos_condiciones',terminos);
          this.terminos = terminos || null;

          if (!this.terminos || !this.terminos.id) {
            this.msg = 'No se encontraron terminos para la unidad de negocio actual';
            return;
          }

          const res = await terminos_aceptaciones_por({
            terminos_id: this.terminos.id,
          });
          this.aceptaciones = Array.isArray(res) ? res : [];
        } catch (e) {
          window.console.error(e);
          this.msg = 'No se pudo cargar la lista de aceptaciones';
        } finally {
          this.loading = false;
        }
      },
      nombreCompleto(contacto) {
        if (!contacto) return '-';
        return `${contacto.nombres || ''} ${contacto.apellidos || ''}`.trim() || '-';
      },
      valorContacto(item, campo) {
        return item.contacto && item.contacto[campo] ? item.contacto[campo] : '-';
      },
      parseFecha(f) {
        if (!f) return '';
        const fs = f.split('T')[0].split('-');
        if (fs.length !== 3) return f;
        return `${fs[2]}/${fs[1]}/${fs[0]}`;
      },
    },
    mounted() {
      this.listar();
    },
  };
</script>
